import { t } from "@/i18n-js/instance";
import { usePunditUserContext } from "@circle-react/contexts";
import { dateStringToTimeAgo } from "@circle-react/helpers/dateTimeHelpers/timeAgo";
import { Typography } from "@circle-react-uikit/Typography";
import { WarningWrapper } from "./WarningWrapper";

export const SubscriptionOnGracePeriod = () => {
  const { currentCommunity } = usePunditUserContext();

  if (!currentCommunity?.subscription?.ends_at) {
    return null;
  }

  return (
    <WarningWrapper>
      <Typography.LabelLg weight="semibold">
        {t("subscription.subscription_on_grace_period.title")}
      </Typography.LabelLg>
      <Typography.BodyMd color="text-default">
        {t("subscription.subscription_on_grace_period.description", {
          date: dateStringToTimeAgo(currentCommunity?.subscription?.ends_at),
        })}
      </Typography.BodyMd>
    </WarningWrapper>
  );
};
